import i18next from 'i18next'
import React from 'react'
import { Link } from '../../utils/links'

export type BreadcrumbItemProps = {
  title: string,
  url: string
}

export type BreadcrumbProps = {
  links: BreadcrumbItemProps[]
}

export const Breadcrumbs = (p: BreadcrumbProps) => (
  <>
    <nav className="breadcrumb" aria-label={i18next.t('a11y:labelBreadcrumbs')}>
      <ul className="breadcrumb__list">
        {p.links.map((item, index) => (
          <li className="breadcrumb__item" key={item.url}>
            {index == p.links.length - 1 ? (
              <span className='breadcrumb__current label--m' aria-current="location">{item.title}</span>
            ) : (
              <Link url={item.url} className="breadcrumb__link label--m">
                <span className="breadcrumb__label">{item.title}</span>
              </Link>
            )}
          </li>
        ))}
      </ul>
    </nav>
  </>
)
